// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box misc-transaction sss-change-individual-payment">
    <sub-header header="'Generate PRN for an individual'"></sub-header>

    <h2 class="section-header">Generate PRN</h2>
    <form name="\$ctrl.commandForm" novalidate>
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Payor type:</td>
          <td>
            <select name="payorType"
                    ng-model="\$ctrl.payorType"
                    ng-change="\$ctrl.onPayorTypeChange()"
                    ng-options="payorType | translate:'SSS_PAYOR_TYPE' for payorType in \$ctrl.availablePayorTypes"
                    ng-required="true">
            </select>
          </td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Individual number:</td>
          <td>
            <input
                ng-model="\$ctrl.ssNumber"
                ui-mask="99-9999999-9"
                ng-pattern="\$ctrl.ssPattern"
                type="text"
                required
                name="ssNumber"
            />
          </td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Monthly Amount:</td>
          <td>
            <select
                required
                ng-model="\$ctrl.monthlyAmount"
                ng-options="con.value as con.label for con in \$ctrl.getAvailableContributions() track by con.value"
            >
            </select>
          </td>
          <td></td>
        </tr>
        <tr ng-if="\$ctrl.payorType === 'OVERSEAS_WORKER' && \$ctrl.monthlyAmount >= 1760">
          <td></td>
          <td>Flexi fund amount:</td>
          <td>
            <cash ng-model="\$ctrl.flexiFundAmount"
              name="flexiFund"
              ui-validate="{illegalFlexiFundAmount: '\$value == 0 || \$value >= 200'}"></cash>
            <div ng-if="\$ctrl.commandForm.flexiFund.\$error.illegalFlexiFundAmount">
              Flexi fund should be: equal to 0, equal or greater than 200
            </div>
          </td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Starting period:</td>
          <td>
            <input
                name="startingPeriod"
                type="text"
                ng-model="\$ctrl.startingPeriod"
                change="\$ctrl.onStartingPeriodChange()"
                moment-picker
                max-date="\$ctrl.endingPeriod"
                max-view="year"
                format="YYYY MMM"
                required
            />
          </td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Ending period:</td>
          <td>
            <input type="text"
                   name="endingPeriod"
                   ng-model="\$ctrl.endingPeriod"
                   moment-picker
                   min-date="\$ctrl.startingPeriod"
                   max-view="year"
                   format="YYYY MMM"
                   required
            />
          </td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>Total amount:</td>
          <td>
            <input
                disabled
                ng-value="\$ctrl.calculateTotalAmountText()"
                type="text"/>
          </td>
          <td></td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button
            type="button"
            class="misc-transaction__cancel btn btn-warning"
            ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
            type="submit"
            class="misc-transaction__save btn btn-success"
            ng-disabled="\$ctrl.commandForm.\$invalid"
            ng-click="\$ctrl.changePRN()">
          Generate PRN
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/sss-change-individual-prn/sss-change-individual-prn.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;